import * as attachmentsApi from '../../api/attachments';
import { invokeBlobFileDownloading } from '../../utils/commonUtils';
import { handleErrors } from '../ErrorActions';

const createDownloadFileFromData = (data, fileName) => async () => {
  try {
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(data, fileName);
      return;
    }

    invokeBlobFileDownloading(data, fileName);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`Failed to download all attachments : ${JSON.stringify(error)}`);
  }
};

export const downloadAllAttachments = (params) => async (dispatch) => {
  try {
    const { data, headers } = await attachmentsApi.downloadAllAttachments(params);

    if (/json$/gi.test(headers['content-type'])) {
      // if content-type is json, it's an error response
      const reader = new FileReader();
      reader.addEventListener('loadend', () => {
        const { errors = 'Failed to download all attachments' } = JSON.parse(reader.result);
        dispatch(handleErrors(errors));
      });
      reader.readAsText(data);
      return;
    }

    const contentDisposition = headers['content-disposition'];
    let fileName = `${params.entityName}-${params.itmId}-all-attachments.zip`;

    if (contentDisposition) {
      [, fileName] = contentDisposition.match(/filename="(.+)"/);
    }

    dispatch(createDownloadFileFromData(data, fileName));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`downloadAllAttachments() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};
